import { render } from "./FormClient.vue?vue&type=template&id=29ed4cc0&scoped=true"
import script from "./FormClient.vue?vue&type=script&lang=ts"
export * from "./FormClient.vue?vue&type=script&lang=ts"

import "./FormClient.vue?vue&type=style&index=0&id=29ed4cc0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-29ed4cc0"

export default script